export default "__VITE_ASSET__CY5d8V$u__"